import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PDFViewer, Document, Page, Text, View, Image, StyleSheet, Font } from '@react-pdf/renderer';
import img from '../../../assets/restaurant/meteri-logo.png'
import BannerImg from '../../../assets/restaurant/BannerBg.png'

import FontBoldWoff from '../../../assets/font/Montserrat-Bold.woff';
import FontBoldWoff2 from '../../../assets/font/Montserrat-Bold.woff2';
import { toast } from "react-toastify";

// Soft break words longer 
Font.registerHyphenationCallback((word) => {
    if (word.length > 15) {
        return word.match(/.{1,10}/g);
    }
    return [word];
});

Font.register({
    family: 'Montserrat',
    fonts: [
        {
            src: FontBoldWoff,
            fontWeight: 'bold',
        },
        {
            src: FontBoldWoff2,
            fontWeight: 'bold',
        },
    ],
});

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        padding: 20,
        fontSize: 12,
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundSize: 'cover',
        backgroundPosition: 'left center',
        zIndex: -1,
        opacity: 0.3,
    },
    // header: {
    //   marginBottom: 20,
    // },
    WineBorder: {
        borderTop: '1px solid #d8b6ba',
        marginBottom: 5,
        marginTop: 10,
        marginLeft: -20,
        marginRight: -20,
        paddingHorizontal: 20,
    },
    WineListName: {
        maxWidth: '310px',
        // margin: '0 auto',
        margin: '0 auto',
        fontSize: 18,
        textAlign: 'left',
        color: '#7d0a0a',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
        textTransform: 'capitalize',
        wordWrap: 'break-word',
        overflow: 'hidden',
        maxHeight: '70px',
        marginTop: 10,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    wineType: {
        fontSize: 12,
        color: '#5f5f5f',
        fontWeight: 'bold',
        marginTop: 12,
        // marginLeft: 27,
        marginLeft: 30,
    },
    wineCard: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingBottom: 15,
        justifyContent: 'space-between',
        paddingTop: 5,
        gap: 10,
        // borderBottom: '1px solid #f0f0f0',
        pageBreakInside: 'avoid',
        // alignItems:'center'
    },
    dishImageContainer: {
        width: 90,
        height: 90,
        borderRadius: 60,
        overflow: 'hidden',
        marginRight: 20,
        marginTop: 10,
        backgroundColor: '#f0f0f0',
    },
    nodishImageFound: {
        marginLeft: 20,
    },
    dishImage: {
        width: '100%',
        height: '100%',
        resizeMode: 'cover',
    },
    // mainimg: {
    //     width: 50,
    //     height: 115,
    //     marginRight: 15,
    // },
    LogoImage: {
        width: 105,
        height: 45,
        position: 'absolute',
        top: 12,
        left: 15,
        zIndex: 10
    },
    LogoImage1: {
        width: 105,
        height: 45,
        position: 'absolute',
        top: 12,
        right: 15,
        zIndex: 10
    },
    wineDetails: {
        flex: 1,
        paddingTop: 15
    },
    wineName: {
        maxWidth: 400,
        fontSize: 12,
        color: '#7d0a0a',
        marginBottom: 5,
        fontWeight: 'bold',
    },
    allergensMenu: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#000000',
        marginBottom: 5,
    },
    // wineDescription: {
    //     fontSize: 9,
    //     color: '#000000',
    //     marginBottom: 5,
    //     textAlign: 'justify',
    //     lineHeight: 1.3,
    //     maxWidth:'500px'
    // },
    wineDescription: {
        maxWidth: 400,
        fontSize: 9,
        color: '#000000',
        marginBottom: 5,
        textAlign: 'justify',
        lineHeight: 1.3,
    },
    wineAddress: {
        fontSize: 10,
        color: '#5f5f5f',
        marginBottom: 8,
        fontWeight: 'bold',
    },
    // winePrice: {
    //     fontSize: 12,
    //     marginLeft: "auto",
    //     marginTop: 20,
    //     fontWeight: 'bold',
    //     color: '#8B2434',
    // },
    halfPriceContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        marginTop: 15,
    },

    winePrice1: {
        // width:'200px',
        fontSize: 12,
        // marginTop: 6,
        // marginLeft: "auto",
        fontWeight: 'bold',
        color: '#8B2434',
    },
    noWinesContainer: {
        marginTop: 20,
        textAlign: "center",
    },
    noWinesText: {
        fontSize: 16,
        fontWeight: "bold",
        color: "red",
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        fontSize: 12,
        fontWeight: 'bold',
        width: "100%",
        height: "12px",
        backgroundColor: "#8B2434"
    },
    pageContent: {
        flex: 1,
        // marginBottom: 20,
        marginBottom: 10,
        // marginLeft:10,
        // marginRight: 10,
        marginTop: 25,
    },
    fullWidthContent: {
        marginLeft: -20,
        marginRight: -20,
        paddingHorizontal: 20,
    },
    dishContainer: {
        marginBottom: 30
    },

});

const BeveragePDF = () => {
    const { beverage_id } = useParams();
    const [baverageData, setBaverageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const [beverageImageUrls, setBeverageImageUrls] = useState({});
    const [isDownloading, setIsDownloading] = useState(false);
    const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const logo = baverageData &&
        baverageData.length > 0 &&
        baverageData?.[0]?.restaurant_data?.logo
        ? `${logoUrl}/${baverageData?.[0]?.restaurant_data?.logo}`
        : null;

    // const getBeverageData = async () => {
    //     try {
    //         setLoading(true);
    //         const response = await axios.get(
    //             `${apiUrl}/api/v1/category-beverages/${beverage_id}`
    //         );
    //         if (response.status === 200) {
    //             setBaverageData(response.data || []);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching beverage data", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     getBeverageData();
    // }, []);

    useEffect(() => {
        const fetchBeverageData = async () => {
            try {
                setLoading(true);

                // 1. Fetch beverage category data
                const response = await axios.get(
                    `${apiUrl}/api/v1/category-beverages/${beverage_id}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (response.status === 200) {
                    const data = response.data || [];
                    setBaverageData(data);

                    // 2. Preload all beverage images
                    const beveragesWithImages = data.flatMap(category =>
                        category.beverages?.filter(b => b.picture)) || [];

                    const imageUrls = {};

                    await Promise.all(
                        beveragesWithImages.map(async beverage => {
                            try {
                                const imageUrl = `${logoUrl}/${beverage.picture}`;
                                const imageRes = await axios.get(
                                    `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(imageUrl)}`,
                                    {
                                        headers: { Authorization: `Bearer ${token}` },
                                        responseType: "blob"
                                    }
                                );

                                if (imageRes.status === 200) {
                                    imageUrls[beverage.id] = URL.createObjectURL(imageRes.data);
                                }
                            } catch (imageError) {
                                console.error(`Error loading image for beverage ${beverage.id}:`, imageError);
                            }
                        })
                    );

                    setBeverageImageUrls(imageUrls);
                }
            } catch (err) {
                console.error("Error fetching beverage data:", err);
                setBaverageData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBeverageData();

        return () => {
            // Clean up blob URLs
            Object.values(beverageImageUrls).forEach(URL.revokeObjectURL);
        };
    }, [beverage_id]);


    // const stripHtmlTags = (html) => {
    //     const tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = html;
    //     return tempDiv.textContent || tempDiv.innerText || '';
    // };

    const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length > maxLength ? text.substring(0, maxLength - 3) + "..." : text;
    };

    const handleMobileDownload = async () => {
        try {
            setIsDownloading(true);
            const { pdf } = await import('@react-pdf/renderer');
            const blob = await pdf(
                <Document>
                    {renderPages()}
                </Document>
            ).toBlob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `beverage-list-${new Date().toISOString().slice(0, 10)}.pdf`;
            document.body.appendChild(link);
            link.click();

            // Show success toast
            toast.success('Beverage list successfully downloaded', {
                position: "top-center",
                autoClose: 1000,
                theme: 'colored',
            });

            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                setIsDownloading(false);
            }, 100);
        } catch (error) {
            console.error('Error downloading PDF:', error);
            setIsDownloading(false);

            // Show error toast
            toast.error('Failed to download beverage list', {
                position: "top-center",
                autoClose: 2000,
                theme: 'colored'
            });
        }
    };

    const renderBaverageCard = (beverage) => (
        <View style={[styles.wineCard, styles.fullWidthContent]} key={beverage.id}>
            <View style={beverage?.picture ? styles.dishImageContainer : styles.nodishImageFound}>
                {/* {beverage?.picture ? (
                    <Image
                        source={{
                            uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(`${logoUrl}/${beverage.picture}`)}`,
                            method: "GET",
                            headers: { Authorization: `Bearer ${token}` },
                        }}
                        style={styles.dishImage}
                    />
                ) : (
                    <Image source={require('./placeholder.png')} style={styles.dishImage} />
                )} */}

                {beverage?.picture ? (
                    <Image
                        source={{
                            uri: beverageImageUrls[beverage.id] ||
                                `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(`${logoUrl}/${beverage.picture}`)}`,
                            headers: { Authorization: `Bearer ${token}` }
                        }}
                        style={styles.dishImage}
                    />
                ) : (
                    <Image source="" />
                )}

            </View>

            <View style={styles.wineDetails}>
                <Text style={styles.wineName}>{beverage?.name || ""}</Text>
                <Text
                    style={styles.wineDescription}
                // numberOfLines={5}
                // ellipsizeMode="tail"
                >
                    {/* {stripHtmlTags(beverage.description || "")} */}
                    {truncateText((beverage.description || "").replace(/[\r\n]+/g, " "), 550)}
                </Text>
            </View>

            <View style={{ gap: 5 }}>
                {beverage?.full_price && (
                    <View style={styles.halfPriceContainer}>
                        <Text style={styles.winePrice1}>
                            {beverage?.full_price || ""} €
                        </Text>
                    </View>
                )}
            </View>
        </View>
    );

    const renderPages = () => {
        if (!baverageData?.length) {
            return (
                <Page size="A4" style={styles.page}>
                    <Image style={styles.backgroundImage} src={BannerImg} fixed />
                    {logo && (
                        <Image
                            src={{
                                uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
                                method: "GET",
                                headers: { Authorization: `Bearer ${token}` },
                            }}
                            style={styles.LogoImage}
                        />
                    )}
                    <Image style={styles.LogoImage1} src={img} fixed />
                    <Text style={styles.footer} fixed />
                    <Text style={styles.WineListName}>{""}</Text>
                    <View style={styles.noWinesContainer}>
                        <Text style={styles.noWinesText}>No Baverage found.</Text>
                    </View>
                </Page>
            );
        }

        // const pages = [];
        // let currentPageContent = [];
        // let currentBeverageCount = 0;

        // if (baverageData?.length) {
        //     baverageData.forEach((category) => {
        //         if (!category?.beverages || category?.beverages?.length === 0) {
        //             return;
        //         }

        //         currentPageContent.push(
        //             <View key={`category-${category.id}`} style={styles.WineBorder}>
        //                 <Text style={styles.wineType}>{category.name}</Text>
        //             </View>
        //         );

        //         category.beverages.forEach((beverage) => {
        //             if (currentBeverageCount >= 4) {
        //                 pages.push(currentPageContent);
        //                 currentPageContent = [];
        //                 currentBeverageCount = 0;

        //                 currentPageContent.push(
        //                     <View key={`category-${category.id}-cont`} style={styles.WineBorder}>
        //                         <Text style={styles.wineType}>{category.name}</Text>
        //                     </View>
        //                 );
        //             }

        //             currentPageContent.push(renderBaverageCard(beverage));
        //             currentBeverageCount++;
        //         });
        //     });

        //     if (currentPageContent.length > 0) {
        //         pages.push(currentPageContent);
        //     }
        // }

        const pages = [];
        let currentPageContent = [];
        let currentBeverageCount = 0;
        let currentCategory = null;

        if (baverageData?.length) {
            baverageData.forEach((category) => {
                if (!category?.beverages || category?.beverages?.length === 0) {
                    return;
                }

                // Check if we need to start a new page before adding a new category
                if (currentBeverageCount > 0 && currentBeverageCount + category?.beverages?.length > 4) {
                    pages.push(currentPageContent);
                    currentPageContent = [];
                    currentBeverageCount = 0;
                }

                // Add category header only if it's a new page or new category
                if (currentBeverageCount === 0 || currentCategory !== category.id) {
                    currentPageContent.push(
                        <View key={`category-${category.id}`} style={styles.WineBorder}>
                            <Text style={styles.wineType}>{category.name}</Text>
                        </View>
                    );
                    currentCategory = category.id;
                }

                category.beverages.forEach((beverage) => {
                    if (currentBeverageCount >= 4) {
                        pages.push(currentPageContent);
                        currentPageContent = [
                            // Add category header to the new page
                            <View key={`category-${category.id}`} style={styles.WineBorder}>
                                <Text style={styles.wineType}>{category.name}</Text>
                            </View>
                        ];
                        currentBeverageCount = 1; // 1 because we just added the header
                    } else {
                        currentBeverageCount++;
                    }

                    currentPageContent.push(renderBaverageCard(beverage));
                });
            });

            if (currentPageContent.length > 0) {
                pages.push(currentPageContent);
            }
        }

        // const pages = [];
        // let currentPageContent = [];
        // let currentBeverageCount = 0;

        // if (baverageData?.length) {
        //     baverageData.forEach((category) => {
        //         currentPageContent.push(
        //             <View key={`category-${category.id}`} style={styles.WineBorder}>
        //                 <Text style={styles.wineType}>{category.name}</Text>
        //             </View>
        //         );

        //         category.beverages.forEach((beverage) => {
        //             if (currentBeverageCount >= 4) {
        //                 pages.push(currentPageContent);
        //                 currentPageContent = [
        //                     // Add continuation header for the same category
        //                     // <View key={`category-${category.id}-cont`} style={styles.WineBorder}>
        //                     //     <Text style={styles.wineType}>{category.name} (continued)</Text>
        //                     // </View>
        //                 ];
        //                 currentBeverageCount = 0;
        //             }

        //             currentPageContent.push(renderDishCard(beverage));
        //             currentBeverageCount++;
        //         });
        //     });

        //     if (currentPageContent.length > 0) {
        //         pages.push(currentPageContent);
        //     }
        // }

        return pages.map((pageContent, index) => (
            <Page key={`page-${index}`} size="A4" style={styles.page}>
                <Image style={styles.backgroundImage} src={BannerImg} fixed />
                {logo && index === 0 && (
                    <Image
                        src={{
                            uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
                            method: "GET",
                            headers: { Authorization: `Bearer ${token}` },
                        }}
                        style={styles.LogoImage}
                    />
                )}
                <Image style={styles.LogoImage1} src={img} fixed />

                {/* {index === 0 && baverageData?.[0]?.restaurant_data?.beverageListName ? (
                    <Text style={styles.WineListName}>
                        {baverageData?.[0]?.restaurant_data?.beverageListName || "Altre Bevande"}
                    </Text>
                ) : (
                    <Text style={styles.WineListName}>
                        Altre Bevande
                    </Text>
                )
                } */}
                {index === 0 && (
                    <Text style={styles.WineListName}>
                        {baverageData?.[0]?.restaurant_data?.beverageListName || "Altre Bevande"}
                    </Text>
                )}
                <View style={styles.pageContent}>
                    {pageContent}
                </View>
                <Text style={styles.footer} fixed />
            </Page>
        ));
    };

    if (loading) {
        return <div className="flex justify-center items-center h-screen">
            <svg
                aria-hidden="true"
                className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#8B2433]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                />
            </svg>
            <span className="sr-only">Loading...</span>
        </div>
    }

    if (isMobile) {
        return (
            <div className="flex flex-col items-center justify-center h-screen p-4">
                <div className="text-center">

                    <button
                        onClick={handleMobileDownload}
                        disabled={isDownloading}
                        className="px-4 py-2 bg-[#8A2533] text-white rounded-md flex items-center justify-center"
                    >
                        {isDownloading ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Downloading...
                            </>
                        ) : (
                            'Download PDF'
                        )}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <PDFViewer style={{ width: '100%', height: '100vh' }}>
            <Document>
                {renderPages()}
            </Document>
        </PDFViewer>

    );
};

export default BeveragePDF;